/* © 2022 Promethean. All Rights Reserved.
 *
 * Unauthorized copying of this file or any part of this file
 * via any medium is strictly prohibited.
 */

/**
 * Enter keypress to trigger submit or other callback
 * @param e
 * @param callback
 */
export function onEnterKeyPress(e, callback) {
  if (e.key === 'Enter') {
    e.preventDefault();
    callback === null || callback === void 0 || callback(e);
  }
}

/**
 * Enter keypress to trigger submit or other callback
 * @param e
 * @param callback
 */
export function onKeyPress(e, keys, callback) {
  if (keys.includes(e.key)) {
    callback === null || callback === void 0 || callback(e);
  }
}
export function preventSubmit(e) {
  if (e.target.type !== 'submit' && (e.which === 13 || e.keyCode === 13 || e.key === 'Enter')) {
    e.preventDefault();
  }
}